export * from './cookie-service/cookie.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/node_modules/ngx-cookie-service/index.js
// module id = ../../../../ngx-cookie-service/index.js
// module chunks = vendor